// mui
import { Box, Grid, GridProps, SxProps, Typography, TypographyProps } from '@mui/material';

// ui
import { BlockchainHash, BlockchainHashProps } from '../BlockchainHash/BlockchainHash';
import { IconCircle, IconCircleProps } from '../IconCircle/IconCircle';

// props
export interface BoxKeyValueProps {
	BlockchainHashProps?: BlockchainHashProps;
	GridProps?: GridProps;
	IconCircleProps: IconCircleProps;
	label: TypographyProps;
	sxBox?: SxProps;
	value: TypographyProps;
}

export const BoxKeyValue = ({
	BlockchainHashProps,
	GridProps,
	IconCircleProps,
	label,
	sxBox,
	value,
}: BoxKeyValueProps) => {
	return (
		<Box
			sx={(theme) => {
				return {
					borderColor: theme.palette.divider,
					borderRadius: 2,
					borderStyle: 'solid',
					borderWidth: 1,
					padding: theme.spacing(2),
					height: '100%',
					...(sxBox as object),
				};
			}}>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Grid container spacing={2} {...GridProps}>
						<Grid item xs="auto">
							<IconCircle size="sm" {...IconCircleProps} />
						</Grid>
						<Grid item xs={true}>
							<Typography color="brand.grey.500" fontWeight={600} variant="caption" {...label} />
							<Typography fontWeight={600} {...value} />
						</Grid>
					</Grid>
				</Grid>
				{BlockchainHashProps?.hash && (
					<Grid item xs={12}>
						<BlockchainHash isFullWidth={true} {...BlockchainHashProps} />
					</Grid>
				)}
			</Grid>
		</Box>
	);
};
